
const OMISSION = '...' ;
const TITLE_MAX_LENGTH = 50;

export const truncateText = (input, length) =>
    typeof input === 'string' && input.length > length ? input.substr( 0 , length ) + OMISSION : input ;

export const truncateTitle = input => truncateText(input, TITLE_MAX_LENGTH);